import { render } from "./HomeBlockPhotos.vue?vue&type=template&id=4577a5af&scoped=true"
import script from "./HomeBlockPhotos.vue?vue&type=script&lang=js"
export * from "./HomeBlockPhotos.vue?vue&type=script&lang=js"

import "./HomeBlockPhotos.vue?vue&type=style&index=0&id=4577a5af&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4577a5af"]])

export default __exports__